var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 939,
    height: 1024,
    viewBox: "0 0 939 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M469.333 554.667c141.184 0 256-114.816 256-256v-42.667c0-141.184-114.816-256-256-256s-256 114.816-256 256v42.667c0 141.184 114.816 256 256 256z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M781.739 681.856c-200.704-55.595-424.064-55.595-624.811 0-92.373 25.6-156.928 110.208-156.928 205.824v136.32h938.667v-136.32c0-95.616-64.555-180.224-156.928-205.824z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9d9cb4d8e6547aa0b8f4ba31de25fe18.svg";
export { ForwardRef as ReactComponent };